<template>
    <div class="lww-form-item">
        <van-field
            :class="item.customClass"
            v-if="item.type === 'input'"
            v-model="vModel"
            :type="item.inputType"
            :name="item.paramName"
            :label="item.label"
            :required="item.required"
            :disabled="item.disabled"
            :placeholder="item.placeholder || $t('common.placeholder', [item.label])"
            :rules="item.rules"
        />
        <date-picker
            v-if="item.type === 'date'"
            :rightIcon="item.rightIcon || 'underway-o'"
            :paramName="item.paramName"
            :initValue="item.initValue"
            :minDate="item.minDate"
            :required="item.required"
            :disabled="item.disabled"
            :label="item.label"
            :rules="item.rules"
            :format="item.format || 'YYYY-MM-DD'"
        />
        <lww-radio
            v-if="item.type === 'radio'"
            :paramName="item.paramName"
            :initValue="item.initValue"
            :required="item.required"
            :disabled="item.disabled"
            :label="item.label"
            :rules="item.rules"
            :options="item.options"
            :defaultIndex="item.defaultIndex"
        ></lww-radio>
        <lww-checkbox
            v-if="item.type === 'checkbox'"
            :paramName="item.paramName"
            :initValue="item.initValue"
            :required="item.required"
            :disabled="item.disabled"
            :label="item.label"
            :rules="item.rules"
            :options="item.options"
            :defaultIndex="item.defaultIndex"
        ></lww-checkbox>
        <select-picker
            v-if="item.type === 'select'"
            :paramName="item.paramName"
            :paramCode="item.paramCode"
            :initValue="item.initValue"
            :required="item.required"
            :disabled="item.disabled"
            :defaultIndex="item.defaultIndex"
            :label="item.label"
            :rules="item.rules"
            :options="item.options"
        />
        <van-field
            v-if="item.type === 'switch'"
            :label="item.label"
            :required="item.required"
            :name="item.paramName"
            :rules="item.rules"
            :disabled="item.disabled"
        >
            <template #input>
                <van-switch
                    :disabled="item.disabled"
                    v-model="switchChecked"
                    :size="item.size || '24px'"
                    :active-color="item.activeColor || '#07c160'"
                    :inactive-color="item.inactiveColor || '#ccc'"
                    @change="item.onChange || onChange"
                />
            </template>
        </van-field>
        <van-field
            v-if="item.type === 'stepper'"
            :label="item.label"
            :required="item.required"
            :name="item.paramName"
            :rules="item.rules"
            :disabled="item.disabled"
        >
            <template #input>
                <van-stepper
                    v-model="stepper"
                    @change="item.onChange || onChange"
                    :button-size="item.size || '32px'"
                    :min="item.min"
                    :max="item.max"
                    :step="item.step"
                    :disabled="item.disabled"
                />
            </template>
        </van-field>
        <van-field
            v-if="item.type === 'uploader'"
            :label="item.label"
            :required="item.required"
            :name="item.paramName"
            :rules="item.rules"
            :disabled="item.disabled"
        >
            <template #input>
                <van-uploader
                    v-model="uploader"
                    :multiple="item.multiple || false"
                    :max-count="item.multiple ? item.max || 10 : 1"
                    :max-size="item.maxSize"
                    @oversize="item.onOversize || onChange"
                    :after-read="item.onChange || onChange"
                    :disabled="item.disabled"
                />
            </template>
        </van-field>
        <slot></slot>
    </div>
</template>
<script>
export default {
    props: {
        /**
         * @description: 配置项包含参数 更具体的可以细看各个组件
         * @param {string} type：控件类型，必传
         * @param {string} label 标签文本，可不传
         * @param {string} paramName：参数名 （对应select组件的 label）
         * @param {string} paramCode：select组件的 value
         * @param {Array} rules：校验规则，可不传，
         * @param {Array} options：对象数组,select、radio、checkBox等控件需传,例如[{label:'',value:''}]
         * @param {any} initValue 初始值(也是回显时的值)
         * @param {string} title picker的标题 => selectPicker|datePciker
         * @param {Boolean} required 是否必填 只控制样式
         * @param {Boolean} disabled
         * @param {string} customClass 自定义类名
         * @param {string} placeholder
         * @param {Number} defaultIndex  selectPicker的默认项
         */

        item: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            vModel: this.item.initValue || '',
            switchChecked: this.item.initValue || false,
            stepper: this.item.initValue || 0,
            uploader: this.item.initValue || [],
        }
    },
    methods: {
        onChange() {},
    },
    computed: {
        initValue() {
            return this.item.initValue
        },
    },
    watch: {
        initValue(newVal) {
            switch (this.item.type) {
                case 'input':
                    this.vModel = newVal
                    break
                case 'switch':
                    this.switchChecked = newVal
                    break
                case 'stepper':
                    this.stepper = newVal
                    break
                case 'uploader':
                    this.uploader = newVal
                    break
                default:
                    break
            }
        },
    },
}
</script>
<style lang="less">
.van-cell::after {
    display: none;
}
.lww-form-item {
    position: relative;
    &::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 16px;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
    }
}
</style>
